import { DEFAULT_LOCALE, isLocale, type Locale } from '@unibyte/contracts/locales';

/**
 * Initial locale for the iframe before any conversation exists (guide §10 step 4):
 * explicit `lang` from the host (site/plugin default) > browser languages > platform default.
 * Visitor selection (manual mode) and message-language detection are layered on top in Prompt 6.
 */
export function resolveInitialLocale(
  requestedLang: string | null | undefined,
  browserLanguages: readonly string[] = [],
  fallback: Locale = DEFAULT_LOCALE,
): Locale {
  const normalizedRequest = normalize(requestedLang);
  if (normalizedRequest && isLocale(normalizedRequest)) return normalizedRequest;

  for (const language of browserLanguages) {
    const normalized = normalize(language);
    if (normalized && isLocale(normalized)) return normalized;
  }
  return fallback;
}

function normalize(value: string | null | undefined): string | null {
  if (!value) return null;
  const primary = value.trim().toLowerCase().split(/[-_]/)[0];
  return primary && primary.length > 0 ? primary : null;
}
